import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_RECRUIT_SIGN_DIGEST_CONFIG = defineFcm('octopus_recruit_sign_digest_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				bandit_subject_line_experiment: {
					type: 'object',
					shape: {
						experiment_name: { type: 'string' },
						constraints: {
							type: 'array',
							shape: { type: 'string' },
						},
					},
					optional: true,
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
